export const pivotTableFunctionTypes = [
  { id: 1, name: 'Sum' },
  { id: 2, name: 'Average' },
];